module.exports = __webpack_public_path__ + "img/attachment.cb5d4991.svg";